import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Avatar, AvatarFallback } from "./ui/avatar";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { User, CreditCard, Database, ShieldCheck, LogOut } from "lucide-react";

export function AccountMenu() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const label = user?.preferred_name || user?.name || user?.email || "U";
  const initials = label.trim().slice(0, 2).toUpperCase();

  const go = (to) => navigate(to);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="account-menu-trigger" className="df-pressable outline-none rounded-full shrink-0">
        <Avatar className="h-9 w-9 border border-slate-200">
          <AvatarFallback className="bg-[#0D786A] text-white text-xs font-semibold">{initials}</AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-2xl" data-testid="account-menu">
        <DropdownMenuLabel className="pb-2">
          <div className="font-semibold text-slate-900 truncate">{user?.preferred_name || user?.name || "Your account"}</div>
          <div className="text-xs font-normal text-slate-400 truncate">{user?.email}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="menu-profile" onClick={() => go("/profile")} className="cursor-pointer">
          <User size={16} className="mr-2 text-slate-500" /> Profile
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="menu-subscription" onClick={() => go("/more")} className="cursor-pointer">
          <CreditCard size={16} className="mr-2 text-slate-500" /> Subscription
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="menu-data" onClick={() => go("/more/privacy")} className="cursor-pointer">
          <Database size={16} className="mr-2 text-slate-500" /> Data &amp; Backup
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="menu-security" onClick={() => go("/more/security")} className="cursor-pointer">
          <ShieldCheck size={16} className="mr-2 text-slate-500" /> Security
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="menu-logout" onClick={logout} className="cursor-pointer text-red-600 focus:text-red-600">
          <LogOut size={16} className="mr-2" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
